module.exports = __webpack_public_path__ + "img/gruppo-mail-prjweb.010c9bf9.png";